import { Button, Flex, Form, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { HotelSelect } from "../../common/HotelSelect";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import { mdlMarketCopyToOtherHotelsRequest } from "../../../models/service-models/market/MarketCopyToOtherHotelsRequest";
import { MarketService } from "../../../services/MarketService";

export type CopyMarketToOtherHotelsProps = {
    fromHotelId?: string;
    marketIds?: string[];
    callback?: Function;
}

export const CopyMarketToOtherHotels = (props: CopyMarketToOtherHotelsProps) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const { mutateAsync: copyMarketToOtherHotels, isLoading: mutateLoading, data: mutatedData } = useMutation(
        (data: mdlMarketCopyToOtherHotelsRequest) => MarketService.Copy(data as mdlMarketCopyToOtherHotelsRequest),
        {
            onMutate(variables) {
                variables.fromHotelId = props.fromHotelId;
                variables.marketIds = props.marketIds;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body) {
                    if (data.body.isSuccessful === true) {
                        toast.success(t("common.success"));
                        props.callback && props.callback();
                    }
                    else {
                        toast.error(data.body.message);
                    }
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    )

    return (
        <>
            <Spin spinning={mutateLoading}>
                <Form
                    form={form}
                    name="copyMarketToOtherHotelsForm"
                    layout="vertical"
                    onFinish={async (values) => copyMarketToOtherHotels(values)}
                    autoComplete="off"
                >
                    <Form.Item<mdlMarketCopyToOtherHotelsRequest>
                        label={t("definitions.boards.hotels")}
                        name="toHotelIds"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <HotelSelect onChange={(value: string[]) => form.setFieldsValue({ hotelIds: value })} mode="multiple" />
                    </Form.Item>
                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </Spin>
        </>
    )
}